"use client";

import type { TextColor } from "@homeinstead/schemas";

import { cn } from "@homeinstead/ui";
import { Button } from "@homeinstead/ui/components/Button";
import { ChevronLeft } from "lucide-react";
import { inquiryTextColorClass } from "./inquiry-text-color";

type InquiryStepBackButtonProps = {
  className?: string;
  onBack: () => void;
  textColor?: TextColor;
};

function InquiryStepBackButton({
  className,
  onBack,
  textColor,
}: InquiryStepBackButtonProps) {
  return (
    <Button
      className={cn(
        "-ml-1 inline-flex h-auto items-center gap-1.5 self-start py-0 pr-2 pb-6 pl-1 font-semibold text-base hover:bg-transparent focus-visible:ring-offset-background",
        inquiryTextColorClass(textColor),
        "hover:opacity-80",
        className,
      )}
      onClick={onBack}
      type="button"
      variant="plain"
    >
      <ChevronLeft aria-hidden className="size-6 shrink-0" strokeWidth={2.5} />
      <span>Back</span>
    </Button>
  );
}

export { InquiryStepBackButton };
